import { Dialog, DialogTitle } from '@mui/material';

import { BulkDistributionForm } from './BulkDistributionForm/BulkDistributionForm';
import { useBulkDistribution } from './hooks/useBulkDistribution';
import { BulkTicketDistributionModalProps } from './types';

export const BulkTicketDistributionModal: React.FC<BulkTicketDistributionModalProps> = ({
  isOpened,
  handleClose,
  ticket,
}) => {
  const {
    selectedUsers,
    userSearchQuery,
    setUserSearchQuery,
    isDistributing,
    usersData,
    isUsersLoading,
    isValidating,
    handleAddUser,
    handleAddUsersByTelegram,
    handleRemoveUser,
    handleDistribute,
    validateUsernames,
    resetState,
  } = useBulkDistribution(ticket.id);

  const handleModalClose = () => {
    if (!isDistributing) {
      resetState();
      handleClose();
    }
  };

  return (
    <Dialog open={isOpened} onClose={handleModalClose} maxWidth="md" fullWidth>
      <DialogTitle>Ticket Distribution: {ticket.title}</DialogTitle>

      <BulkDistributionForm
        userSearchQuery={userSearchQuery}
        onUserSearchChange={setUserSearchQuery}
        usersData={usersData}
        isUsersLoading={isUsersLoading}
        selectedUsers={selectedUsers}
        onAddUser={handleAddUser}
        onAddUsersByTelegram={handleAddUsersByTelegram}
        onRemoveUser={handleRemoveUser}
        isDistributing={isDistributing}
        isValidating={isValidating}
        onSubmit={handleDistribute}
        onClose={handleModalClose}
        onValidateUsernames={validateUsernames}
      />
    </Dialog>
  );
};
